import {
  OptionInstance,
  GhModelType,
  StyleAssetType,
} from '@swd_admin/cdc-viewer';
import { BillOfMaterials } from 'api';
import create from 'zustand';
import { PaintColor } from 'components/materialssidebar/tabpane';

type UiState = {
  activeOption: (OptionInstance & { unDeletable?: boolean }) | undefined;
  setActiveOption: (option: OptionInstance | undefined) => void;
  bom: BillOfMaterials | undefined;
  setBom: (bom: BillOfMaterials) => void;
  addNewLastLocation: (location: string) => void;
  setRehydrated: () => void;
  lastLocation: string | undefined;
  _locations: Array<string>;
  rehydrated: boolean;
  viewerLoadingModelType: GhModelType | undefined;
  setViewerLoadingModelType: (ghModelType: GhModelType | undefined) => void;
  viewerFirstLoading: boolean;
  setViewerFirstLoading: (viewerLoading: boolean) => void;
  viewerBusy: boolean;
  setViewerBusy: (busy: boolean) => void;
  mobileBottomSheetSnap: number;
  setMobileBottomSheetSnap: (snap: number) => void;
  activeTabKey: string | undefined;
  setActiveTabKey: (key: string) => void;
  selectedColor: PaintColor;
  setSelectedColor: (color: PaintColor) => void;
  removableInstanceIds: string[] | undefined;
  setRemovableInstanceIds: (removableInstanceIds: string[] | undefined) => void;
  focusType: StyleAssetType | null;
  setFocusType: (focusType: StyleAssetType | null) => void;
  isFromWebsite: boolean;
  setIsFromWebsite: (isFromWebsite: boolean) => void;
  savingInProgress: { portfolio: boolean } | undefined;
  setSavingInProgress: (
    savingInProgress: { portfolio: boolean } | undefined
  ) => void;
};

export const useUiState = create<UiState>((set, get) => {
  return {
    _locations: [],
    rehydrated: false,
    lastLocation: undefined,
    activeOption: undefined,
    viewerFirstLoading: false,
    viewerLoadingModelType: undefined,
    bom: undefined,
    viewerBusy: false,
    mobileBottomSheetSnap: 2,
    activeTabKey: undefined,
    selectedColor: {
      siding: null,
      trim: null,
    },
    removableInstanceIds: undefined,
    focusType: null,
    isFromWebsite: false,
    savingInProgress: undefined,
    setActiveOption: (option) =>
      set(() => ({
        activeOption: option,
      })),
    setBom: (bom: BillOfMaterials) => {
      set(() => ({
        bom,
      }));
    },
    setViewerLoadingModelType: (
      viewerLoadingModelType: GhModelType | undefined
    ) => set(() => ({ viewerLoadingModelType })),
    setViewerFirstLoading: (
      viewerFirstLoading: boolean
    ) => set(() => ({ viewerFirstLoading })),

    setRehydrated: () => set(() => ({ rehydrated: true })),
    setViewerBusy: (busy: boolean) => set(() => ({ viewerBusy: busy })),
    setMobileBottomSheetSnap: (snap: number) =>
      set(() => ({ mobileBottomSheetSnap: snap })),
    addNewLastLocation: (newLocation: string) => {
      const locations = get()._locations;
      locations.push(newLocation);
      const lastLocation = locations.length > 1 ? locations.shift() : undefined;
      set(() => ({
        lastLocation,
        _locations: locations,
      }));
    },
    setActiveTabKey: (activeTabKey: string) => set(() => ({ activeTabKey })),
    setSelectedColor: (color: PaintColor) =>
      set(() => ({ selectedColor: color })),
    setRemovableInstanceIds: (removableInstanceIds: string[] | undefined) =>
      set(() => ({ removableInstanceIds })),
    setFocusType: (focusType: StyleAssetType | null) =>
      set(() => ({ focusType })),
    setIsFromWebsite: (isFromWebsite: boolean) =>
      set(() => ({ isFromWebsite })),
    setSavingInProgress: (savingInProgress) =>
      set(() => ({ savingInProgress })),
  };
});

export const showRenderResult = () => {
  const { mobileBottomSheetSnap, setMobileBottomSheetSnap } =
    useUiState.getState();
  if (mobileBottomSheetSnap !== 1) {
    setMobileBottomSheetSnap(1);
  }
};
